import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from '../Partial/Header';
import Footer from '../Partial/Footer';
import { BASE_URL, BASE_IMAGE_URL, BASE_HREF } from '../config';
import { useParams, useNavigate } from 'react-router-dom';
import { Markup } from 'interweave';
import LoaderOverlay from '../Partial/LoaderOverlay';



const ProductDetails = () => {

    const { id } = useParams();
    let [productData, setProductData] = useState("");
    const [firstKey, setFirstKey] = useState(null);
    const [loading, setLoading] = useState(true);


    let fetchData = async () => {
        try {
            setLoading(true);
            const res = await axios.get(`${BASE_URL}/get-search-by-category`, {
                params: { category_id: atob(id) }
            });

            if (res.data.responseCode === 200) {
                const data = res.data.responseData;
                setProductData(data);

                const partDetails = data.part_details;
                const key = Object.keys(partDetails)[0];
                setFirstKey(key);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchData();

    }, []);

    return (
        <>
            {loading && <LoaderOverlay />}
            <Header />
            {productData ? (
                <>
                    <section className="searchcontainer">
                        <span className="seachpattern">
                            <svg width={525} height={454} viewBox="0 0 525 454" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M524.996 -2.76343H-356.388M524.996 59.5334H-356.388M524.996 121.83H-356.388M524.996 184.127H-356.388M524.996 246.424H-356.388M524.996 308.721H-356.388M524.996 371.018H-356.388M524.996 433.315H-356.388M473.582 453.426L473.582 -6.8772M399.749 453.426L399.749 -6.8772M325.916 453.426L325.916 -6.8772M252.083 453.426L252.082 -6.8772M178.25 453.426L178.249 -6.8772M104.417 453.426L104.417 -6.8772M30.584 453.426L30.584 -6.8772M-43.249 453.426V-6.8772M-117.082 453.426V-6.8772M-190.915 453.426V-6.8772M-264.748 453.426V-6.8772M-338.581 453.426V-6.8772" stroke="url(#paint0_linear_87_29)" strokeOpacity="0.08" />
                                <defs>
                                    <linearGradient id="paint0_linear_87_29" x1="-223.192" y1="337.222" x2="217.544" y2="163.201" gradientUnits="userSpaceOnUse">
                                        <stop stopColor="white" stopOpacity={0} />
                                        <stop offset="0.5" stopColor="white" />
                                        <stop offset={1} stopColor="white" stopOpacity={0} />
                                    </linearGradient>
                                </defs>
                            </svg>
                        </span>
                        <span className="seachpattern seachpatternrt">
                            <svg width={525} height={454} viewBox="0 0 525 454" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M524.996 -2.76343H-356.388M524.996 59.5334H-356.388M524.996 121.83H-356.388M524.996 184.127H-356.388M524.996 246.424H-356.388M524.996 308.721H-356.388M524.996 371.018H-356.388M524.996 433.315H-356.388M473.582 453.426L473.582 -6.8772M399.749 453.426L399.749 -6.8772M325.916 453.426L325.916 -6.8772M252.083 453.426L252.082 -6.8772M178.25 453.426L178.249 -6.8772M104.417 453.426L104.417 -6.8772M30.584 453.426L30.584 -6.8772M-43.249 453.426V-6.8772M-117.082 453.426V-6.8772M-190.915 453.426V-6.8772M-264.748 453.426V-6.8772M-338.581 453.426V-6.8772" stroke="url(#paint0_linear_87_29)" strokeOpacity="0.08" />
                                <defs>
                                    <linearGradient id="paint0_linear_87_29" x1="-223.192" y1="337.222" x2="217.544" y2="163.201" gradientUnits="userSpaceOnUse">
                                        <stop stopColor="white" stopOpacity={0} />
                                        <stop offset="0.5" stopColor="white" />
                                        <stop offset={1} stopColor="white" stopOpacity={0} />
                                    </linearGradient>
                                </defs>
                            </svg>
                        </span>
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-xxl-8 col-xl-8 col-lg-10 col-md-12 col-sm-12 col-12">
                                    <div className="searchbox">
                                        {/* <h1>{productData.product_name} {productData.category_name}</h1> */}
                                        <h1>{productData.product_name}</h1>
                                        <ol className="breadcrumb justify-content-center">
                                            <li className="breadcrumb-item"><a href={BASE_HREF}>Home</a></li>
                                            <li className="breadcrumb-item"><a href={`${BASE_HREF}product-view`}>Products</a></li>
                                            {/* <li className="breadcrumb-item active" aria-current="page">{productData.product_name} {productData.category_name}</li> */}
                                            <li className="breadcrumb-item active" aria-current="page">{productData.product_name}</li>
                                        </ol>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="productdetails">
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                                    <div className="productltbx">
                                        <img src={`${BASE_IMAGE_URL}${productData.image_path}`} alt="" />
                                    </div>
                                </div>
                                <div className="col-xxl-7 col-xl-7 col-lg-8 col-md-6 col-sm-6 col-12 d-flex">
                                    <div className="productrtbx">
                                        {/* <h2>{productData.product_name}</h2>
                                        <Markup content={productData?.product_des} /> */}
                                        <img src={`${BASE_IMAGE_URL}${productData?.er_diagram_image}`} alt="" />
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-0 mt-md-5 pt-3">
                                <div className="col-12">
                                    <div className="table-responsive">
                                        {productData?.part_details && Object.keys(productData.part_details).length > 0 ? (
                                            <table className="table">
                                                <thead>
                                                    <tr>
                                                        <th rowSpan={2} colSpan={2}>Part Number</th>
                                                        <th rowSpan={3}>Cap MFD</th>
                                                        <th colSpan={4}>Maximum RMS Current (Amp) at</th>
                                                    </tr>
                                                    <tr>
                                                        <th>3 Mhz</th>
                                                        <th>1 Mhz</th>
                                                        <th>.3 Mhz</th>
                                                        <th>.1 Mhz</th>
                                                    </tr>
                                                    <tr>
                                                        <th>RCA</th>
                                                        <th>CDE</th>
                                                        <th colSpan={5}>
                                                            {firstKey ? `${firstKey} volts Peak Working Voltage` : "Peak Working Voltage"}
                                                        </th>
                                                    </tr>
                                                </thead>
                                                {(() => {
                                                    const voltageKeys = Object.keys(productData.part_details);
                                                    const [firstKey, ...restKeys] = voltageKeys;
                                                    const firstGroup = productData.part_details[firstKey];

                                                    return (
                                                        <>

                                                            <tbody>
                                                                {firstGroup.map((part, index) => (
                                                                    <tr key={`${firstKey}-${index}`}>
                                                                        <td>{part.rca}</td>
                                                                        <td>{part?.cde || "-"}</td>
                                                                        <td>{part.cap_mfd}</td>
                                                                        <td>{part.mhz_3 || "-"}</td>
                                                                        <td>{part.mhz_1 || "-"}</td>
                                                                        <td>{part.mhz3 || "-"}</td>
                                                                        <td>{part.mhz1 || "-"}</td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>


                                                            {restKeys.map(voltage => (
                                                                <React.Fragment key={voltage}>
                                                                    <thead>
                                                                        <tr>
                                                                            <th colSpan={7}>{voltage} volts Peak Working Voltage</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {productData.part_details[voltage].map((part, idx) => (
                                                                            <tr key={`${voltage}-${idx}`}>
                                                                                <td>{part.rca}</td>
                                                                                <td>{part?.cde || "-"}</td>
                                                                                <td>{part.cap_mfd}</td>
                                                                                <td>{part.mhz_3 || "-"}</td>
                                                                                <td>{part.mhz_1 || "-"}</td>
                                                                                <td>{part.mhz3 || "-"}</td>
                                                                                <td>{part.mhz1 || "-"}</td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </React.Fragment>
                                                            ))}
                                                        </>
                                                    );
                                                })()}
                                            </table>
                                        ) : (
                                            <div>No data found</div>
                                        )}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </>
            ) : (
                <section className="searchcontainer">
                    <span className="seachpattern">
                        <svg width={525} height={454} viewBox="0 0 525 454" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M524.996 -2.76343H-356.388M524.996 59.5334H-356.388M524.996 121.83H-356.388M524.996 184.127H-356.388M524.996 246.424H-356.388M524.996 308.721H-356.388M524.996 371.018H-356.388M524.996 433.315H-356.388M473.582 453.426L473.582 -6.8772M399.749 453.426L399.749 -6.8772M325.916 453.426L325.916 -6.8772M252.083 453.426L252.082 -6.8772M178.25 453.426L178.249 -6.8772M104.417 453.426L104.417 -6.8772M30.584 453.426L30.584 -6.8772M-43.249 453.426V-6.8772M-117.082 453.426V-6.8772M-190.915 453.426V-6.8772M-264.748 453.426V-6.8772M-338.581 453.426V-6.8772" stroke="url(#paint0_linear_87_29)" strokeOpacity="0.08" />
                            <defs>
                                <linearGradient id="paint0_linear_87_29" x1="-223.192" y1="337.222" x2="217.544" y2="163.201" gradientUnits="userSpaceOnUse">
                                    <stop stopColor="white" stopOpacity={0} />
                                    <stop offset="0.5" stopColor="white" />
                                    <stop offset={1} stopColor="white" stopOpacity={0} />
                                </linearGradient>
                            </defs>
                        </svg>
                    </span>
                    <span className="seachpattern seachpatternrt">
                        <svg width={525} height={454} viewBox="0 0 525 454" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M524.996 -2.76343H-356.388M524.996 59.5334H-356.388M524.996 121.83H-356.388M524.996 184.127H-356.388M524.996 246.424H-356.388M524.996 308.721H-356.388M524.996 371.018H-356.388M524.996 433.315H-356.388M473.582 453.426L473.582 -6.8772M399.749 453.426L399.749 -6.8772M325.916 453.426L325.916 -6.8772M252.083 453.426L252.082 -6.8772M178.25 453.426L178.249 -6.8772M104.417 453.426L104.417 -6.8772M30.584 453.426L30.584 -6.8772M-43.249 453.426V-6.8772M-117.082 453.426V-6.8772M-190.915 453.426V-6.8772M-264.748 453.426V-6.8772M-338.581 453.426V-6.8772" stroke="url(#paint0_linear_87_29)" strokeOpacity="0.08" />
                            <defs>
                                <linearGradient id="paint0_linear_87_29" x1="-223.192" y1="337.222" x2="217.544" y2="163.201" gradientUnits="userSpaceOnUse">
                                    <stop stopColor="white" stopOpacity={0} />
                                    <stop offset="0.5" stopColor="white" />
                                    <stop offset={1} stopColor="white" stopOpacity={0} />
                                </linearGradient>
                            </defs>
                        </svg>
                    </span>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-xxl-8 col-xl-8 col-lg-10 col-md-12 col-sm-12 col-12">
                                <div className="searchbox">
                                    <h1>No Data Found </h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            )}

            <Footer />
        </>
    );
};

export default ProductDetails;